{
    "ReportingMenu_FirstClosePopup": "To reopen the menu, click the 'CX Analytics' button in the sidebar whilst on the CX Analytics page.",
    "NAME": "ReportingMenuLanguage"
}
